import {Model} from 'vue-mc'
import moment from 'moment-timezone'

class ValidTodayAbility extends Model {
  defaults() {
    return {
      id: null,
      active_dates: null,
      valid_from: null, valid_until: null,
      klass: 'Addon',
    }
  }

  mutations() {
    return {
      valid_from:  (str) => typeof str === 'string' ? moment(str).tz(window.time_zone) : null,
      valid_until: (str) => typeof str === 'string' ? moment(str).tz(window.time_zone) : null,
    }
  }

  // ruby: (self.class == Section || not_archived?) && (!active_dates? || today_in_dates)
  valid_today(){
    return (this.klass === "Section" || !this.archived) && (!this.is_active_dates() || this.today_in_dates())
  }

  today_in_dates(){
    const now = moment().unix()
    if (this.valid_from && this.valid_until)
      return moment(this.valid_from).unix() < now && now < moment(this.valid_until).unix()
    else if (this.valid_until)
      return now < moment(this.valid_until).unix()
    else if (this.valid_from)
      return now > moment(this.valid_from).unix()
    else
      return true
  }

  is_active_dates(){
    return this.active_dates || this.valid_from || this.valid_until
  }
}

export {
  ValidTodayAbility
}
